export const changePassword = async (resource, id, data) => {
    let result
    await resource
        .put(`api/${localStorage.getItem('perfil')}/user/new_passwd/` + id, data)
        .then(
            (response) => {
                result = response.body.user
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}